import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-on-site-with-stripe',
  templateUrl: './payment-panel-on-site-with-stripe.component.html',
})
export class PaymentPanelOnSiteWithStripeComponent {}
